import { Box, Flex, IconButton, Text } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import React, { FC, Suspense } from 'react'
import { system as s } from '@moonpig/launchpad-system'
import { SkeletonCarousel } from '@moonpig/web-shared-components'
import { IconSystemCross } from '@moonpig/launchpad-assets'
import { useLocaleText } from './MoreLikeThisPanel.locale'
import { AddedToBasketEvent } from '../../types'
import {
  CARD_HEIGHT,
  CARD_WIDTH,
  NUMBER_OF_PRODUCTS_TO_FETCH,
} from './constants'
import { MoreLikeThisProducts, PanelArrow } from './components'

const StyledPanel = styled(Box)`
  ${s({
    width: { xs: 'calc(100% - 24px)', md: 'calc(100% - 36px)' },
    position: 'relative',
    bgcolor: 'colorBackground03',
    p: 6,
    pt: 4,
    ml: { xs: 6, md: 8 },
    mr: { xs: 4, lg: 5 },
    mt: { xs: 4, md: 0 },
    mb: 6,
    borderRadius: 4,
    alignItems: 'center',
  })}
`

const StyledHeader = styled(Flex)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

const StyledTitle = styled(Text)`
  ${s({
    mb: 0,
    typography: 'typeDisplay04',
  })}
`

type Props = {
  productId: string
  triggerProduct: {
    ref: React.RefObject<HTMLButtonElement>
    index: number
  }
  onAddToBasket: (addedEvent: AddedToBasketEvent) => void
  onClose: () => void
}

export const MoreLikeThisPanel: FC<Props> = ({
  productId,
  triggerProduct,
  onAddToBasket,
  onClose,
}) => {
  const localiseText = useLocaleText()
  const panelRef = React.useRef<HTMLDivElement>(null)

  return (
    <StyledPanel ref={panelRef}>
      <PanelArrow panelRef={panelRef} triggerProductRef={triggerProduct.ref} />
      <Box>
        <StyledHeader>
          <StyledTitle as="h3">
            {localiseText('more_like_this.title')}
          </StyledTitle>
          <IconButton
            label={localiseText('more_like_this.close_button_label')}
            icon={IconSystemCross}
            onClick={onClose}
          />
        </StyledHeader>
        {`This is the productId to be used when querying MoreLikeThis: ${productId}`}
        <Suspense
          fallback={
            <SkeletonCarousel
              numberOfBoxes={NUMBER_OF_PRODUCTS_TO_FETCH}
              hideTitle
              boxHeight={CARD_HEIGHT}
              boxWidth={CARD_WIDTH}
            />
          }
        >
          <MoreLikeThisProducts onAddToBasket={onAddToBasket} />
        </Suspense>
      </Box>
    </StyledPanel>
  )
}
